<template>
  <LoginLayoutFrame
    :login-text="$t('auth.Authorization')"
    :brand-text="$t('header.automated_animal_recording_system')"
    :copyright-text="$t('auth.rights')"
  >
    <template #language-selector>
      <LanguageSelector />
    </template>
    <slot />
  </LoginLayoutFrame>
</template>
<script setup lang="ts">
import { LoginLayoutFrame } from 'r3ui-lib/login';
import LanguageSelector from '~/modules/locale/LanguageSelector.vue';
</script>
